/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotshopDomainDeletedDto,
  ApiEnvelopeBotshopDomainDto,
  ApiEnvelopeBotshopDomainListDto,
  ApiEnvelopeBotshopShopAssignmentDto,
  ApiEnvelopeBotshopShopAssignmentListDto,
  AssignBotshopDomainRequest,
  CreateBotshopDomainRequest,
  UpdateBotshopDomainRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botshopDomainsAdminGetDomainsResponse200 = {
  data: ApiEnvelopeBotshopDomainListDto
  status: 200
}

export type botshopDomainsAdminGetDomainsResponseSuccess = (botshopDomainsAdminGetDomainsResponse200) & {
  headers: Headers;
};
;

export type botshopDomainsAdminGetDomainsResponse = (botshopDomainsAdminGetDomainsResponseSuccess)

export const getBotshopDomainsAdminGetDomainsUrl = () => {




  return `/api/admin/botshop-domains`
}

export const useBotshopDomainsAdminGetDomainsHook = (): ( options?: RequestInit) => Promise<botshopDomainsAdminGetDomainsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminGetDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botshopDomainsAdminCreateDomainResponse200 = {
  data: ApiEnvelopeBotshopDomainDto
  status: 200
}

export type botshopDomainsAdminCreateDomainResponse400 = {
  data: ApiEnvelopeBotshopDomainDto
  status: 400
}

export type botshopDomainsAdminCreateDomainResponseSuccess = (botshopDomainsAdminCreateDomainResponse200) & {
  headers: Headers;
};
export type botshopDomainsAdminCreateDomainResponseError = (botshopDomainsAdminCreateDomainResponse400) & {
  headers: Headers;
};

export type botshopDomainsAdminCreateDomainResponse = (botshopDomainsAdminCreateDomainResponseSuccess | botshopDomainsAdminCreateDomainResponseError)

export const getBotshopDomainsAdminCreateDomainUrl = () => {




  return `/api/admin/botshop-domains`
}

export const useBotshopDomainsAdminCreateDomainHook = (): (createBotshopDomainRequest?: CreateBotshopDomainRequest, options?: RequestInit) => Promise<botshopDomainsAdminCreateDomainResponse> => {

      const customFetcher = useSfetchMutator();
      return (createBotshopDomainRequest?: CreateBotshopDomainRequest, options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminCreateDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBotshopDomainRequest)
  }
);
      }
  }


export type botshopDomainsAdminUpdateDomainResponse200 = {
  data: ApiEnvelopeBotshopDomainDto
  status: 200
}

export type botshopDomainsAdminUpdateDomainResponse400 = {
  data: ApiEnvelopeBotshopDomainDto
  status: 400
}

export type botshopDomainsAdminUpdateDomainResponse404 = {
  data: ApiEnvelopeBotshopDomainDto
  status: 404
}

export type botshopDomainsAdminUpdateDomainResponseSuccess = (botshopDomainsAdminUpdateDomainResponse200) & {
  headers: Headers;
};
export type botshopDomainsAdminUpdateDomainResponseError = (botshopDomainsAdminUpdateDomainResponse400 | botshopDomainsAdminUpdateDomainResponse404) & {
  headers: Headers;
};

export type botshopDomainsAdminUpdateDomainResponse = (botshopDomainsAdminUpdateDomainResponseSuccess | botshopDomainsAdminUpdateDomainResponseError)

export const getBotshopDomainsAdminUpdateDomainUrl = (id: string,) => {




  return `/api/admin/botshop-domains/${id}`
}

export const useBotshopDomainsAdminUpdateDomainHook = (): (id: string,
    updateBotshopDomainRequest?: UpdateBotshopDomainRequest, options?: RequestInit) => Promise<botshopDomainsAdminUpdateDomainResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateBotshopDomainRequest?: UpdateBotshopDomainRequest, options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminUpdateDomainUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateBotshopDomainRequest)
  }
);
      }
  }


export type botshopDomainsAdminDeleteDomainResponse200 = {
  data: ApiEnvelopeBotshopDomainDeletedDto
  status: 200
}

export type botshopDomainsAdminDeleteDomainResponse404 = {
  data: ApiEnvelopeBotshopDomainDeletedDto
  status: 404
}

export type botshopDomainsAdminDeleteDomainResponseSuccess = (botshopDomainsAdminDeleteDomainResponse200) & {
  headers: Headers;
};
export type botshopDomainsAdminDeleteDomainResponseError = (botshopDomainsAdminDeleteDomainResponse404) & {
  headers: Headers;
};

export type botshopDomainsAdminDeleteDomainResponse = (botshopDomainsAdminDeleteDomainResponseSuccess | botshopDomainsAdminDeleteDomainResponseError)

export const getBotshopDomainsAdminDeleteDomainUrl = (id: string,) => {




  return `/api/admin/botshop-domains/${id}`
}

export const useBotshopDomainsAdminDeleteDomainHook = (): (id: string, options?: RequestInit) => Promise<botshopDomainsAdminDeleteDomainResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminDeleteDomainUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type botshopDomainsAdminGetShopsResponse200 = {
  data: ApiEnvelopeBotshopShopAssignmentListDto
  status: 200
}

export type botshopDomainsAdminGetShopsResponseSuccess = (botshopDomainsAdminGetShopsResponse200) & {
  headers: Headers;
};
;

export type botshopDomainsAdminGetShopsResponse = (botshopDomainsAdminGetShopsResponseSuccess)

export const getBotshopDomainsAdminGetShopsUrl = () => {




  return `/api/admin/botshop-domains/shops`
}

export const useBotshopDomainsAdminGetShopsHook = (): ( options?: RequestInit) => Promise<botshopDomainsAdminGetShopsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminGetShopsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botshopDomainsAdminAssignShopResponse200 = {
  data: ApiEnvelopeBotshopShopAssignmentDto
  status: 200
}

export type botshopDomainsAdminAssignShopResponse400 = {
  data: ApiEnvelopeBotshopShopAssignmentDto
  status: 400
}

export type botshopDomainsAdminAssignShopResponse404 = {
  data: ApiEnvelopeBotshopShopAssignmentDto
  status: 404
}

export type botshopDomainsAdminAssignShopResponseSuccess = (botshopDomainsAdminAssignShopResponse200) & {
  headers: Headers;
};
export type botshopDomainsAdminAssignShopResponseError = (botshopDomainsAdminAssignShopResponse400 | botshopDomainsAdminAssignShopResponse404) & {
  headers: Headers;
};

export type botshopDomainsAdminAssignShopResponse = (botshopDomainsAdminAssignShopResponseSuccess | botshopDomainsAdminAssignShopResponseError)

export const getBotshopDomainsAdminAssignShopUrl = (sellbotConfigId: string,) => {




  return `/api/admin/botshop-domains/shops/${sellbotConfigId}`
}

export const useBotshopDomainsAdminAssignShopHook = (): (sellbotConfigId: string,
    assignBotshopDomainRequest?: AssignBotshopDomainRequest, options?: RequestInit) => Promise<botshopDomainsAdminAssignShopResponse> => {

      const customFetcher = useSfetchMutator();
      return (sellbotConfigId: string,
    assignBotshopDomainRequest?: AssignBotshopDomainRequest, options?: RequestInit) => {

        return customFetcher(getBotshopDomainsAdminAssignShopUrl(sellbotConfigId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignBotshopDomainRequest)
  }
);
      }
  }


